/*
 * @Description: In User Settings Edit
 * @Author: wangsx
 * @Date: 2020-05-28 16:11:00
 * @LastEditors: your name
 * @LastEditTime: 2022-01-25 10:09:18
 */
// import { logout } from "@/api/login";
import { ElMessage, ElLoading } from "element-plus";
import router from "@/router";
import axios from "axios";
import util from "@util/js";
// import qs from 'qs' 暂未安装日后需要再装,功能是将url解析为对象或将对象转为url，方便和后台对接口。
// 创建axios实例

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  // baseURL: 'http://localhost:8080/',
  // 超时
  timeout: 300000
});
let loading = false;

function openloading(loadingDom) {
  loading = ElLoading.service({
    lock: true,
    text: "正在加载中...",
    background: "rgba(255,255,255,0.7)",
    target: loadingDom || "body"
  })
}

function closeloading() {
  loading && loading.close()
}


// 添加请求拦截器
service.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token");
    config.headers.common.token = token;
    if (config.loading) {
      openloading(config.loadingDom)
    }

    // if (config.url == "/apiData/hz-data-community/zghz/znyy/file-similar") {
    //   config.headers = {
    //     "Content-Type": "application/x-www-form-urlencoded"
    //   }
    // }
    // const cusNumber = localStorage.getItem("currentCusNumber") || "";
    // const DEPTTYPE = localStorage.getItem("DEPTTYPE");
    // if (DEPTTYPE && DEPTTYPE === "ZD") {
    //   const cusNumber = localStorage.getItem("prisonCusNumber");
    //   config.headers.common.cusNumber = cusNumber;
    // }
    // if (cusNumber && cusNumber !== "") {
    //   if (config.method === "post") {
    //     if (!config.data) {
    //       config.data = {};
    //     }
    //     config.data.customerNum = cusNumber;
    //   }
    //   if (config.method === "get") {
    //     if (!config.params) {
    //       config.params = {};
    //     }
    //     config.params.customerNum = cusNumber;
    //   }
    // }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);
// 退出登录
const toLogin = () => {
  // const res = await logout();
  const token = util.getStorage("token");
  if (token) {
    ElMessage.error("登录信息已过期，需要重新登陆！");
    util.removeStorage("token");
    util.removeStorage("username");
    util.removeStorage("regionId");
    util.removeStorage("userDeptId");
    router.push({ name: "login" });
  }
};

// 添加响应拦截器
service.interceptors.response.use(
  response => {
    // 在这里处理全局响应
    // 错误处理
    closeloading()
    if (response.data.code === 500) {

      ElMessage.warning(response.data.msg);
      return Promise.reject(response.data);
    } else if (response.data.code === 401) {
      toLogin();
      return Promise.reject(response.data);
    }
    return response.data;
  },
  error => {
    // 在这里处理全局错误
    closeloading()
    if (!error.response) {
      ElMessage.warning("数据返回失败，请重试");
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject("断网了，后端未启动");
    }
    if (error.response.status === 401) {
      toLogin();
    } else {
      ElMessage.warning("数据返回失败，请重试！");
    }

    return Promise.reject(error.response);
  }
);

export default service;